<script lang="ts" setup>
import { useResponsive } from "@composables"
import { useFormStore } from "@stores/form.store"
import { computed } from "vue"

const { snapshot } = useFormStore()

const steps = computed(() => {
    return [
        {
            title: "Adresse et compteur",
            progress:
                snapshot.value.context.step > 0
                    ? 100
                    : snapshot.value.context.step === 0
                      ? snapshot.value.context.stepProgress
                      : 0,
        },
        {
            title: "L'essentiel",
            progress:
                snapshot.value.context.step > 1
                    ? 100
                    : snapshot.value.context.step === 1
                      ? snapshot.value.context.stepProgress
                      : 0,
        },
        {
            title: "Facultatif, mais utile",
            progress:
                snapshot.value.context.step > 2
                    ? 100
                    : snapshot.value.context.step === 2
                      ? snapshot.value.context.stepProgress
                      : 0,
        },
    ]
})

const { isMobile } = useResponsive()
</script>
<template>
    <div class="form-stepper" v-if="!isMobile">
        <FormStepperItem
            v-for="(step, index) in steps"
            :key="index"
            :step="index + 1"
            :title="step.title"
            :progress="step.progress"
        ></FormStepperItem>
    </div>
    <FormStepperMobile v-else :steps="steps"></FormStepperMobile>
</template>

<style scoped>
.form-stepper {
    display: flex;
    align-items: flex-start;
    gap: 0.25rem;
}
</style>
